import Model from "../../classes/model/Model";
import User from "./User";

/**
 * @property {int} id
 * @property {int} old_id
 * @property {int} company_id
 * @property {int} responsible_id
 * @property {int} manager_id
 * @property {int} source
 * @property {string} first_name
 * @property {string} last_name
 * @property {string} email
 * @property {string} phone
 * @property {int} birthday
 * @property {string} comment
 * @property {int} status
 * @property {int} sub_status
 * @property {int} is_archive
 * @property {int} sms_notification
 *
 * @property {int} created_by
 * @property {int} updated_by
 * @property {int} created_at
 * @property {int} updated_at
 *
 * @property {User} creator
 * @property {User} updater
 */
export default class Client extends Model {

    relations() {
        return {
            creator: {class: User, many: false},
            updater: {class: User, many: false},
        };
    }

    get fullName() {
        let pieces = [];
        if (this.first_name) {
            pieces.push(this.first_name);
        }
        if (this.last_name) {
            pieces.push(this.last_name);
        }
        return pieces.join(' ');
    }

}
